import styled from 'styled-components'
import { maxXs } from '../../styles/breakPoints'
import background2 from '../../pages/LandingPage/img/background-2.png'

export const Container = styled.div`
  width: 100%;
`

export const Body = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  flex: 0 0 auto;

  .cases-section {
    @media (${maxXs}) {
      padding-left: 20px;
      padding-right: 20px;
    }

    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;

    margin-bottom: 154px;

    @media (${maxXs}) {
      margin-bottom: 60px;
    }

    .title {
      text-align: center;
      width: 518px;
      margin-bottom: 104px;

      @media (${maxXs}) {
        margin-bottom: 60px;
      }

      h1 {
        text-align: center;
        margin-bottom: 20px;
        margin-top: 120px;

        @media (${maxXs}) {
          margin-top: 60px;
        }
      }

      @media (${maxXs}) {
        width: 296px;
      }
    }

    .quotes-container {
      cursor: grab;
      width: 698px;
      @media (${maxXs}) {
        width: 100%;
      }
    }

    .quotes-container:active {
      cursor: grabbing;
    }

    .background {
      width: 698px;
      background: url(${background2});
      background-repeat: no-repeat;
      background-size: contain;
      background-position: center;
      height: fit-content;
      padding: 20px;

      @media (${maxXs}) {
        padding-left: 20px;
        padding-right: 20px;
      }

      img {
        height: 24px;
        width: auto;
        margin-bottom: 23px;
        object-fit: contain;
      }

      .text {
        text-align: center;
        margin-bottom: 11px;
        line-height: 2.5;

        @media (${maxXs}) {
          text-align: left;
          line-height: 1.23;
        }

        .quotes {
          font-size: 42px;
          line-height: 0.5;
          @media (${maxXs}) {
            font-size: 24px;
          }
        }
      }

      .person {
        display: flex;
        flex-direction: column;

        span {
          text-align: end;
        }
      }

      @media (${maxXs}) {
        width: 100%;
      }
    }

    .cta {
      display: flex;
      justify-content: center;

      button {
        width: 155px;
        margin-top: 10px;

        a {
          text-decoration: none;
          width: 100%;
        }
      }
    }
  }
`
